import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { TacticsAndTechniquesWebComponentSchema, Technique } from '../types';
import { GzLabeledContentWebComponent } from '../../../ui/gzLabeledContent';
import { ImageState } from '../../../ui/gzImageRepo/types';
import { LinkColor, LinkType } from '../../../ui/gzLinkComponent/types';
import { GzLinkWebComponent } from '../../../ui/gzLinkComponent';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { GzTooltipWebComponent } from '../../../ui/gzTooltip';
import { htmlEncode } from '../../../utils/escape.utils';

export class TacticsAndTechniquesView extends BaseWebComponentView {
  readonly MITRE_URL = 'https://attack.mitre.org/techniques';

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$title = this.shadow.querySelector('#title');
    this.dom.$tactics = this.shadow.querySelector('#tactics');
  }

  buildSuccessView(data: TacticsAndTechniquesWebComponentSchema) {
    const { mitreTags } = data;

    this.dom.$title.innerText = this.dependencies.translateFn('ATT&CK TACTICS AND TECHNIQUES');

    if (mitreTags.length === 0) {
      this.buildEmptyView();
      return;
    }
    mitreTags.forEach(tactic => {
      const tacticElement = new GzLabeledContentWebComponent();
      tacticElement.labelFontWeight = FontWeights.NORMAL;
      tacticElement.labelFontSize = FontSizes.PARAGRAPH_12;
      tacticElement.label = htmlEncode(tactic.category);
      tactic.techniques.forEach((technique, index) => {
        const techniqueContainer = document.createElement('div');
        techniqueContainer.className = 'technique-container';
        techniqueContainer.append(this.generateMitreLink(technique.id));

        const techniqueNameTooltip = new GzTooltipWebComponent();
        techniqueNameTooltip.tooltipText = htmlEncode(technique.name);

        const divTechniqueName = document.createElement('div');
        divTechniqueName.className = 'technique-name';
        divTechniqueName.innerHTML = htmlEncode(technique.name);

        techniqueNameTooltip.append(divTechniqueName);
        techniqueContainer.append(techniqueNameTooltip);
        tacticElement.append(techniqueContainer);
      });

      this.dom.$tactics.append(tacticElement);
    });
  }

  public buildErrorView(error: Error) {
    this.dom.$title.innerText = this.dependencies.translateFn('ATT&CK TACTICS AND TECHNIQUES');

    const errorText = this.dependencies.translateFn('An error has occurred while fetching MITRE info.');
    this.dom.$tactics.innerHTML = `
        <gz-image-repo state="${ImageState.ERROR}">
          <gz-text>
            ${errorText}
          </gz-text>
        </gz-image-repo>`;
  }

  buildEmptyView(): void {
    const noTacticsText = this.dependencies.translateFn('MITRE info not available.');
    this.dom.$tactics.innerHTML = `
        <gz-image-repo state="${ImageState.EMPTY}">
          <gz-text class="empty-view" fontWeight="500" fontSize="16">
            ${noTacticsText}
          </gz-text>
        </gz-image-repo>`;
  }

  generateMitreLink(techniqueId: string): GzLinkWebComponent {
    const mitreLink = new GzLinkWebComponent();
    mitreLink.fontSize = FontSizes.PARAGRAPH_12;
    mitreLink.color = LinkColor.PRIMARY;
    mitreLink.showIcon = false;
    mitreLink.innerHTML = htmlEncode(techniqueId);
    mitreLink.href = `${this.MITRE_URL}/${techniqueId}`;
    mitreLink.type = LinkType.QUIET;

    return mitreLink;
  }
}
